import { ChildGender } from "~/types";

export const formatGender = (gender?: ChildGender): string => {
  if (gender === "boy") return "băiețel";
  if (gender === "girl") return "fetiță";
  return "-";
};
